import { file } from 'paths.macro'
import store from '@/store'

const initialState = {
  version: '',
  appVersion: '',
}

export const version = {
  namespaced: true,
  state: localStorage.getItem('version') ? JSON.parse(localStorage.getItem('version')) : initialState,
  mutations: {
    setVersion(state, version) {
      state.version = version
    },
    setAppVersion(state, appVersion) {
      state.appVersion = appVersion
    },
  },
  actions: {
    initVersion({ dispatch, commit }) {
      this.loadAppVersion()
    },
    loadAppVersion({ dispatch, commit }) {
      console.log('loading app version')
    },
  },
}
